// extracted by mini-css-extract-plugin
export default {"line":"HistoryTabel_line__J-hks","lineItem":"HistoryTabel_lineItem__0oOoL","lineItemEnd":"HistoryTabel_lineItemEnd__QrZdS"};